/* eslint-disable camelcase */
import Vue from 'vue'
import Router from 'vue-router'
import locale from 'locale2'
import Meta from 'vue-meta'

import Homepage from '@/pages'

import SectionPage from '@/components/SectionPage'

import Introduction_Welcome from '@/pages/introduction/welcome'
import Introduction_WorkIndex from '@/pages/introduction/the-schneider-sustainability-works-index'
import Introduction_SustainabilityAtSchneiderElectric from '@/pages/introduction/sustainability-at-schneider-electric'
import Introduction_EnvironmentalStrategy from '@/pages/introduction/environmental-strategy'

import SustainableSolutions_Ecostruxure from '@/pages/sustainable-solutions/ecostruxure'
import SustainableSolutions_Overview from '@/pages/sustainable-solutions/overview'
import SustainableSolutions_EnergyServices from '@/pages/sustainable-solutions/energy-services'
import SustainableSolutions_Research from '@/pages/sustainable-solutions/research'
import SustainableSolutions_EnergyUniversity from '@/pages/sustainable-solutions/energy-university'
import SustainableSolutions_SupplyChain from '@/pages/sustainable-solutions/supply-chain'

import OurCustomers_Overview from '@/pages/our-customers/overview'
import OurCustomers_Building from '@/pages/our-customers/building'
import OurCustomers_DataCenter from '@/pages/our-customers/data-center'
import OurCustomers_Industry from '@/pages/our-customers/industry'
import OurCustomers_Infrastructure from '@/pages/our-customers/infrastructure'

import OurPeople_Overview from '@/pages/our-people/overview'
import OurPeople_CompanyValues from '@/pages/our-people/company-values'
import OurPeople_CompanyPrograms from '@/pages/our-people/company-programs'
import OurPeople_InvestmentForGrowth from '@/pages/our-people/investment-for-growth'
import OurPeople_LiveLivesBetter from '@/pages/our-people/live-lives-better'

import Outreach_Overview from '@/pages/outreach/overview'
import Outreach_AccessToEnergy from '@/pages/outreach/access-to-energy'
import Outreach_SchneiderElectricFoundation from '@/pages/outreach/schneider-electric-foundation'

import CompanyPerformance_Overview from '@/pages/company-performance/overview'
import CompanyPerformance_YearInReview from '@/pages/company-performance/year-in-review'
import CompanyPerformance_20152017PlanetSocietyBarometer from '@/pages/company-performance/2015-2017-planet-society-barometer'
import CompanyPerformance_Leadership from '@/pages/company-performance/company-leadership'
import CompanyPerformance_Ethics from '@/pages/company-performance/company-ethics'

import LookingAhead_Overview from '@/pages/looking-ahead/overview'
import LookingAhead_2018Priorities from '@/pages/looking-ahead/2018-priorities'
import LookingAhead_SustainabilityApproach from '@/pages/looking-ahead/sustainability-approach'
import LookingAhead_About from '@/pages/looking-ahead/about'

Vue.use(Router)
Vue.use(Meta)

const router = new Router({
  scrollBehavior (to, from, savedPosition) {
    return {x: 0, y: 0}
  },
  mode: 'history',
  routes: [
    {
      path: '/:lang',
      name: 'Homepage',
      component: Homepage
    },
    {
      path: '/:lang/introduction',
      component: SectionPage,
      children: [
        {
          path: 'overview',
          component: Introduction_Welcome,
          name: 'Introduction_Welcome'
        },
        {
          path: 'schneider-sustainability-impact',
          component: Introduction_WorkIndex,
          name: 'Introduction_WorkIndex'
        },
        {
          path: 'sustainability-at-schneider-electric',
          component: Introduction_SustainabilityAtSchneiderElectric,
          name: 'Introduction_SustainabilityAtSchneiderElectric'
        },
        {
          path: 'environmental-strategy',
          component: Introduction_EnvironmentalStrategy,
          name: 'Introduction_EnvironmentalStrategy'
        }
      ]
    },
    {
      path: '/:lang/sustainable-solutions',
      component: SectionPage,
      children: [
        {
          path: 'overview',
          component: SustainableSolutions_Overview,
          name: 'SustainableSolutions_Overview'
        },
        {
          path: 'ecostruxure',
          component: SustainableSolutions_Ecostruxure,
          name: 'SustainableSolutions_Ecostruxure'
        },
        {
          path: 'energy-services',
          component: SustainableSolutions_EnergyServices,
          name: 'SustainableSolutions_EnergyServices'
        },
        {
          path: 'research',
          component: SustainableSolutions_Research,
          name: 'SustainableSolutions_Research'
        },
        {
          path: 'energy-university',
          component: SustainableSolutions_EnergyUniversity,
          name: 'SustainableSolutions_EnergyUniversity'
        },
        {
          path: 'supply-chain',
          component: SustainableSolutions_SupplyChain,
          name: 'SustainableSolutions_SupplyChain'
        }
      ]
    },
    {
      path: '/:lang/our-customers',
      component: SectionPage,
      children: [
        {
          path: 'overview',
          component: OurCustomers_Overview,
          name: 'OurCustomers_Overview'
        },
        {
          path: 'building',
          component: OurCustomers_Building,
          name: 'OurCustomers_Building'
        },
        {
          path: 'data-center',
          component: OurCustomers_DataCenter,
          name: 'OurCustomers_DataCenter'
        },
        {
          path: 'industry',
          component: OurCustomers_Industry,
          name: 'OurCustomers_Industry'
        },
        {
          path: 'infrastructure',
          component: OurCustomers_Infrastructure,
          name: 'OurCustomers_Infrastructure'
        }
      ]
    },
    {
      path: '/:lang/our-people',
      component: SectionPage,
      children: [
        {
          path: 'overview',
          component: OurPeople_Overview,
          name: 'OurPeople_Overview'
        },
        {
          path: 'company-values',
          component: OurPeople_CompanyValues,
          name: 'OurPeople_CompanyValues'
        },
        {
          path: 'company-programs',
          component: OurPeople_CompanyPrograms,
          name: 'OurPeople_CompanyPrograms'
        },
        {
          path: 'investment-for-growth',
          component: OurPeople_InvestmentForGrowth,
          name: 'OurPeople_InvestmentForGrowth'
        },
        {
          path: 'live-lives-better',
          component: OurPeople_LiveLivesBetter,
          name: 'OurPeople_LiveLivesBetter'
        }
      ]
    },
    {
      path: '/:lang/outreach',
      component: SectionPage,
      children: [
        {
          path: 'overview',
          component: Outreach_Overview,
          name: 'Outreach_Overview'
        },
        {
          path: 'access-to-energy',
          component: Outreach_AccessToEnergy,
          name: 'Outreach_AccessToEnergy'
        },
        {
          path: 'schneider-electric-foundation',
          component: Outreach_SchneiderElectricFoundation,
          name: 'Outreach_SchneiderElectricFoundation'
        }
      ]
    },
    {
      path: '/:lang/company-performance',
      component: SectionPage,
      children: [
        {
          path: 'overview',
          component: CompanyPerformance_Overview,
          name: 'CompanyPerformance_Overview'
        },
        {
          path: 'year-in-review',
          component: CompanyPerformance_YearInReview,
          name: 'CompanyPerformance_YearInReview'
        },
        {
          path: '2015-2017-planet-society-barometer',
          component: CompanyPerformance_20152017PlanetSocietyBarometer,
          name: 'CompanyPerformance_20152017PlanetSocietyBarometer'
        },
        {
          path: 'company-leadership',
          component: CompanyPerformance_Leadership,
          name: 'CompanyPerformance_Leadership'
        },
        {
          path: 'company-ethics',
          component: CompanyPerformance_Ethics,
          name: 'CompanyPerformance_Ethics'
        }
      ]
    },
    {
      path: '/:lang/looking-ahead',
      component: SectionPage,
      children: [
        {
          path: 'overview',
          component: LookingAhead_Overview,
          name: 'LookingAhead_Overview'
        },
        {
          path: '2018-priorities',
          component: LookingAhead_2018Priorities,
          name: 'LookingAhead_2018Priorities'
        },
        {
          path: 'an-intergrated-approach-to-sustainability',
          component: LookingAhead_SustainabilityApproach,
          name: 'LookingAhead_SustainabilityApproach'
        },
        {
          path: 'about',
          component: LookingAhead_About,
          name: 'LookingAhead_About'
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (!to.params.lang) {
    // No language parameter, add one and redirect
    const lang = locale.toLowerCase().split('-')[0]
    const path = '/' + lang + to.path
    next(path)
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js